import React, { useEffect, useReducer, useState } from "react";

import { Paper } from "@mui/material";

import { SCSGenericButton } from "app/modules/common/components/Buttons/SCSButtons";
import CabeceraCuentaCredito from "../components/CabeceraCuentaCredito";
import SpinnerLoadSrx from "app/modules/shared/components/SpinnerLoadSrx";
import ModalHandleNotification from "app/modules/common/components/Modals/ModalHandleNotificaciones/ModalHandleNotification";

import {
  consultarEstadoCredito,
  crearGenerarLinkPago,
} from "../services/transaccionalService";

import {
  initialModalState,
  modalNotificacionReducer,
} from "app/modules/common/components/Modals/ModalHandleNotificaciones/modalNotificacionReducer";
import { useSelector } from "react-redux";
import EmailEstructura from "app/modules/shared/classes/EstructuraEmail";
import ModalEnvioLinkOtros from "../components/ModalEnvioLinkOtros";

const DetalleLinkPaymentPlux = ({ datosBusqueda }) => {
  const { authUser } = useSelector(({ auth }) => auth);
  const [cabenceraTransaccional, setCabenceraTransaccional] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [loadingMail, setloadingMail] = useState(false);
  const [loadingWhatsApp, setLoadingWhatsApp] = useState(false);

  const [modalSendOtros, setModalSendOtros] = useState(false);

  const [modalState, modalDispatch] = useReducer(
    modalNotificacionReducer,
    initialModalState
  );

  useEffect(() => {
    const getCabeceraTsx = async () => {
      try {
        const respuestaCabeceraTsx = await consultarEstadoCredito(
          datosBusqueda.identificacion,
          datosBusqueda.idGrupo
        );

        if (respuestaCabeceraTsx.state) {
          setCabenceraTransaccional(respuestaCabeceraTsx.data);

          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };

    getCabeceraTsx();
  }, []);

  if (isLoading) {
    return <SpinnerLoadSrx />;
  }

  if (
    cabenceraTransaccional.idCuenta <= 0 ||
    cabenceraTransaccional.idCuenta === null
  ) {
    return <h2>Cliente no posee cuenta.!!</h2>;
  }

  const validarGrupoPago = () => {
    if (Number(1 === 1)) {
      return Number(995);
    } else {
      return Number(995);
    }
  };

  const handleSendByMail = async (values) => {
    let clienteContacto;

    if (typeof values === "object") {
      clienteContacto = cabenceraTransaccional.email;
    } else {
      clienteContacto = values;
    }

    if (clienteContacto === "" || !clienteContacto) {
      modalDispatch({
        type: "SHOW_WARNING",
        title: "PAGO",
        message: "Cliente no cuenta con email registrado.",
      });

      setloadingMail(false);

      return;
    }

    setloadingMail(true);

    const informacionGenerarLink = {
      identificacion: cabenceraTransaccional?.identificacion,
      idReferencia: cabenceraTransaccional.idCuenta,
      idLocal: validarGrupoPago(),
      idGrupo: Number(cabenceraTransaccional?.idGrupo),
      tipo: "CRED",
      origen: "SCS",
      valorAPagar: cabenceraTransaccional?.valorPagar,
      celular: cabenceraTransaccional?.celular ?? "",
      email: cabenceraTransaccional?.email ?? "",
      esRecurrencia: false,
      usuario: authUser.key,
      host: authUser.estacion,
    };

    let respuestaGenerarLink;

    try {
      respuestaGenerarLink = await crearGenerarLinkPago(informacionGenerarLink);

      if (respuestaGenerarLink?.mensaje?.codigo === "00") {
        const urlPago = respuestaGenerarLink?.url;
      } else {
        modalDispatch({
          type: "SHOW_WARNING",
          title: "PAGO",
          message: "No se ha podido obtener el link de pago.",
        });
      }
    } catch (error) {
      console.log(error);
      modalDispatch({
        type: "SHOW_WARNING",
        title: "PAGO",
        message: "No se ha podido obtener el link de pago.",
      });
    }
    if (respuestaGenerarLink.url === "") {
      modalDispatch({
        type: "SHOW_WARNING",
        title: "PAGO",
        message: "No se ha podido obtener el link de pago.",
      });

      return;
    }

    const informacionData = `${cabenceraTransaccional.nombreCliente}|${respuestaGenerarLink.url}`;

    const estadosCuentaEmail = new EmailEstructura(
      1,
      "PAGPLX",
      "SENDGRID",
      "EMAIL",
      informacionData,
      clienteContacto,
      111
    );

    try {
      const respSendEmail = await estadosCuentaEmail.sendEmail();

      if (respSendEmail.state) {
        if (respSendEmail.data !== 0) {
          modalDispatch({
            type: "SHOW_SUCCESS",
            title: "PAGOS",
            message: `Se ha enviado el link de pago al correo: ${clienteContacto}`,
            urlRoute: true,
          });
        } else {
          modalDispatch({
            type: "SHOW_WARNING",
            title: "PAGOS",
            message: "Error|05: No se ha podido enviar el link de pago.",
          });
        }
      } else {
        modalDispatch({
          type: "SHOW_WARNING",
          title: "PAGOS",
          message: "Error|06: No se ha podido enviar el link de pago.",
        });
      }
    } catch (error) {
      console.log(error);
      modalDispatch({
        type: "SHOW_WARNING",
        title: "PAGOS",
        message: "Error|07: No se ha podido enviar el link de pago.",
      });
    } finally {
      setloadingMail(false);
      setModalSendOtros(false);
    }
  };

  const handleSendByWhatsApp = async (values) => {
    let clienteContacto;

    if (typeof values === "object") {
      clienteContacto = cabenceraTransaccional.celular;
    } else {
      clienteContacto = values;
    }

    console.log(clienteContacto);

    if (clienteContacto === "" || !clienteContacto) {
      modalDispatch({
        type: "SHOW_WARNING",
        title: "PAGO",
        message: "Cliente no cuenta con celular registrado.",
      });

      setloadingMail(false);

      return;
    }

    setLoadingWhatsApp(true);

    const informacionGenerarLink = {
      identificacion: cabenceraTransaccional?.identificacion,
      idReferencia: cabenceraTransaccional.idCuenta,
      idLocal: validarGrupoPago(),
      idGrupo: Number(cabenceraTransaccional?.idGrupo),
      tipo: "CRED",
      origen: "SCS",
      valorAPagar: cabenceraTransaccional?.valorPagar,
      celular: cabenceraTransaccional?.celular ?? "",
      email: cabenceraTransaccional?.email ?? "",
      esRecurrencia: false,
      usuario: authUser.key,
      host: authUser.estacion,
    };

    let respuestaGenerarLink;

    try {
      respuestaGenerarLink = await crearGenerarLinkPago(informacionGenerarLink);

      if (respuestaGenerarLink?.mensaje?.codigo === "00") {
        const urlPago = respuestaGenerarLink?.url;
      } else {
        modalDispatch({
          type: "SHOW_WARNING",
          title: "PAGO",
          message: "No se ha podido obtener el link de pago.",
        });
        setLoadingWhatsApp(false);
      }
    } catch (error) {
      console.log(error);
      modalDispatch({
        type: "SHOW_WARNING",
        title: "PAGO",
        message: "No se ha podido obtener el link de pago.",
      });
      setLoadingWhatsApp(false);
    }

    if (respuestaGenerarLink.url === "") {
      modalDispatch({
        type: "SHOW_WARNING",
        title: "PAGO",
        message: "No se ha podido obtener el link de pago.",
      });

      setLoadingWhatsApp(false);
      return;
    }

    const informacionData = `${cabenceraTransaccional.nombreCliente}|${respuestaGenerarLink.url}`;

    const estadosCuentaEmail = new EmailEstructura(
      1,
      "PAGPLX",
      "CREDITOFAVORITO",
      "WHATSAPP",
      informacionData,
      clienteContacto,
      111
    );

    try {
      const respSendEmail = await estadosCuentaEmail.sendEmail();

      if (respSendEmail.state) {
        if (respSendEmail.data !== 0) {
          modalDispatch({
            type: "SHOW_SUCCESS",
            title: "PAGOS",
            message: `Se ha enviado el link de pago al celular: ${clienteContacto}`,
            urlRoute: true,
          });
        } else {
          modalDispatch({
            type: "SHOW_WARNING",
            title: "PAGOS",
            message: "Error|05: No se ha podido enviar el link de pago.",
          });
        }
      } else {
        modalDispatch({
          type: "SHOW_WARNING",
          title: "PAGOS",
          message: "Error|06: No se ha podido enviar el link de pago.",
        });
      }
    } catch (error) {
      console.log(error);
      modalDispatch({
        type: "SHOW_WARNING",
        title: "PAGOS",
        message: "Error|07: No se ha podido enviar el link de pago.",
      });
    } finally {
      setLoadingWhatsApp(false);
      setModalSendOtros(false);
    }
  };

  const handleModalOtros = () => {
    setModalSendOtros(true);
  };

  return (
    <div>
      <CabeceraCuentaCredito
        datosBusqueda={datosBusqueda}
        cabenceraTransaccional={cabenceraTransaccional}
      />

      <section className="linkPaymentPlux-options">
        <Paper
          sx={{
            borderRadius: "25px",
            minWidth: "21vw",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "2rem 1rem 2rem 1rem",
          }}
          elevation={2}
        >
          <h3>
            <strong>EMAIL</strong>
          </h3>

          <img
            src="/images/gmail-icon.png"
            style={{ height: "5rem" }}
            alt="Gmail Logo"
          />

          <h5>{`Correo: ${cabenceraTransaccional.email}`}</h5>

          <SCSGenericButton
            titulo="Enviar"
            loading={loadingMail}
            size={70}
            onClick={handleSendByMail}
          />
        </Paper>
        <Paper
          sx={{
            borderRadius: "25px",
            minWidth: "21vw",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "4rem 1.5rem 4rem 1.5rem",
          }}
          elevation={2}
        >
          <h3>
            <strong>WHASTAPP</strong>
          </h3>

          <img
            src="/images/whatsapp-icon.png"
            style={{ height: "5rem" }}
            alt="Gmail Logo"
          />

          <h5>{`Celular: ${cabenceraTransaccional.celular}`}</h5>
          <SCSGenericButton
            titulo="Enviar"
            loading={loadingWhatsApp}
            size={70}
            onClick={handleSendByWhatsApp}
          />
        </Paper>
        <Paper
          sx={{
            borderRadius: "25px",
            minWidth: "21vw",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "4rem 1.5rem 4rem 1.5rem",
          }}
          elevation={2}
        >
          <h3>
            <strong>OTRO</strong>
          </h3>

          <SCSGenericButton
            titulo="Otros"
            size={70}
            onClick={handleModalOtros}
          />
        </Paper>
      </section>

      <ModalEnvioLinkOtros
        open={modalSendOtros}
        setOpen={setModalSendOtros}
        handleSendByMail={handleSendByMail}
        handleSendByWhatsApp={handleSendByWhatsApp}
      />

      <ModalHandleNotification
        parameters={modalState}
        setOpen={() => modalDispatch({ type: "CLOSE_MODAL" })}
      />
    </div>
  );
};

export default DetalleLinkPaymentPlux;
